import { defineComponent as _defineComponent } from 'vue'
import CustomerOrderDate from "@/views/Customers/model/CustomerOrderDate";
  import {PropType, reactive} from "vue";
  import {MessageTypes} from "@/components/message-types";
  import EmployeeName from "@/model/EmployeeName";
  import {t} from "@/mixin/mixins";
  import eventBus from "@/eventbus";
  import router from "@/router";
  import {formatDate} from "@/filter";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerOrdersPast',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array as PropType<Array<CustomerOrderDate>>,
      required: true,
      default: () => new Array<CustomerOrderDate>()
    }
  },
  emits: ["avgPosChanged"],
  setup(__props, { emit }) {

const props = __props

  class AvgRowModel {
    numberOfPositions: number | null;
  }

  

  const initialState = {
    avgItem: {} as AvgRowModel
  };
  const state = reactive({...initialState});

  const headers = [
    {
      text: t("date.text"),
      value: "fromDate",
      align: "left"
    },
    {
      text: t("orderName"),
      value: "order.name",
      align: "left"
    },
    {
      text: t("date.start"),
      value: "start",
      align: "left"
    },
    {
      text: t("date.end"),
      value: "end",
      align: "left"
    },
    {
      text: t("employee.teamlead"),
      value: "order.teamLeader",
      align: "left"
    },
    {
      text: t("employee.employeeCount"),
      value: "employeeCount",
      align: "end"
    },
    {
      text: t("order.operators.numberOfPositions"),
      value: "numberOfPositions",
      align: "end"
    },
    {
      text: t("order.operators.positionsPerHour"),
      value: "positionsPerHour",
      align: "end"
    },
    {
      text: t("time.hours"),
      value: "minutes",
      align: "end"
    },
    {
      value: "actions",
      width: 104,
      sortable: false
    }
  ];

  const openOrderInNew = (item: CustomerOrderDate) => {
    let routeData = router.resolve({
      path: `/orders/${item.order.id}/worklogs`,
      query: {view: "table", date: item.fromDate.slice(0, 7)}
    });
    window.open(routeData.href, "_blank");
  };

  const openNotes = (item: CustomerOrderDate) => {
    eventBus.$emit(MessageTypes.INFO, t("order.orderInfo.notes.title"), item.order.notes);
  };

  const date = (item: CustomerOrderDate) => {
    if(item.fromDate === item.toDate) {
      return formatDate(item.fromDate, "DD.MM.YYYY (dd)");
    } else {
      return formatDate(item.fromDate, "DD") + " - " + formatDate(item.toDate, "DD.MM.YYYY (dd)");
    }
  };

  const fullName = (employee: EmployeeName) => {
    return employee ? `${employee.firstName} ${employee.lastName}` : "–";
  };

  const positionsPerHour = (item: CustomerOrderDate) => {
    if (item.numberOfPositions && item.minutes && item.minutes > 0) {
      const positionsPerHour = item.numberOfPositions / (item.minutes / 60);
      return Math.round(positionsPerHour);
    } else {
      return "–";
    }
  };

  

  const currentItems = (currentItems: CustomerOrderDate[]) => {
    calcAvgPos(currentItems);
  };

  const calcAvgPos = (currentItems: CustomerOrderDate[]) => {
    if (currentItems?.length > 0) {
      const relevantItems = currentItems.filter(item => item.numberOfPositions && item.numberOfPositions > 0);
      const sum = relevantItems.reduce((pos, currentItem) =>
        pos + currentItem.numberOfPositions, 0);
      const avg = sum / relevantItems.length;
      const avgPos = Math.round(avg);
      state.avgItem.numberOfPositions = avgPos;
      emit("avgPosChanged", avgPos);
    }
  };

return { __sfc: true,AvgRowModel, props, initialState, state, headers, openOrderInNew, openNotes, date, fullName, positionsPerHour, emit, currentItems, calcAvgPos, t }
}

})